import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import MainLayout from './pages/AgentChat/AgentChatPage';
import AgentCreationWizard from './pages/AgentCreation/AgentCreationPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AgentRedirect from './pages/RedirectPage';
import InvitePage from './pages/InvitePage';
import OnboardingPage from './pages/OnboardingPage';
import { checkSurveyCompletion } from './lib/database';

const AppRoutes = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      const surveyCompleted = localStorage.getItem('onboardingCompleted') === 'true';
      if (surveyCompleted) {
        return;
      }

      // If not in localStorage, check Supabase
      checkSurveyCompletion(user.id, 'onboarding').then(completed => {
        if (completed) {
          localStorage.setItem('onboardingCompleted', 'true');
        } else {
          // Prevent redirection if already on a public or onboarding path
          const currentPath = window.location.pathname;
          if (currentPath !== '/login' && currentPath !== '/onboarding') {
            navigate('/onboarding');
          }
        }
      });
    }
  }, [user, loading, navigate]);

  return (
    <div className="App h-screen bg-white">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/" element={
          <ProtectedRoute>
            <AgentRedirect />
          </ProtectedRoute>
        } />
        <Route 
          path="/agent" 
          element={
            <ProtectedRoute>
              <AgentRedirect />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/agent/:agentId" 
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/create" 
          element={
            <ProtectedRoute>
              <AgentCreationWizard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/edit/:agentId" 
          element={
            <ProtectedRoute>
              <AgentCreationWizard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/profile" 
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/invite/:agentId" 
          element={
            <ProtectedRoute>
              <InvitePage />
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;